import { render, staticRenderFns } from "./ExtrasList.vue?vue&type=template&id=2563ba72&"
import script from "./ExtrasList.vue?vue&type=script&lang=js&"
export * from "./ExtrasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports